<template>
  <section id="HomeProductSection" ref="MainContent">
    <div class="main_container">
      <header class="section_header">
        <div class="text_box">
          <h3 class="sub_title" data-section-sub-title>
            {{ title }}
          </h3>
        </div>
        <router-link :to="link" class="main_button"
          >查看更多車款
          <span class="icon material-symbols-rounded"> east </span>
        </router-link>
      </header>

      <ol class="product_list">
        <li
          class="product_item"
          v-for="(item, itemIndex) in productData"
          :key="`product_${itemIndex}`"
          data-card-item
          :style="{ transform: `translateX(${page * -100}%)` }"
        >
          <ProductCard :item="item" />
        </li>
      </ol>

      <div class="action_box">
        <div class="button_box">
          <button @click="PrevPage">
            <span class="icon material-symbols-rounded"> west </span>
          </button>
          <button @click="NextPage">
            <span class="icon material-symbols-rounded"> east </span>
          </button>
        </div>
        <router-link :to="link" class="main_button"
          >查看更多車款
          <span class="icon material-symbols-rounded"> east </span>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import { ProductTool } from "@/tools/productTool";
import { ServiceSection } from "@/animations/home/serviceSection.js";
import ProductCard from "@/components/productList/ProductCard.vue";
export default {
  name: "HomeProductSection",
  components: {
    ProductCard,
  },
  props: {
    title: {
      type: String,
      default: "最新優惠車款",
    },
    link: {
      type: String,
      default: "/collection",
    },
    menuId: {
      default: 1,
    },
  },
  data() {
    return { animation: null, page: 0 };
  },
  methods: {
    InitAnimation() {
      this.animation = new ServiceSection(this.$refs.MainContent);
      this.animation.Reset();
    },
    SetAnimation() {
      // this.animation.Reset();
      // this.animation.Setup();
    },
    NextPage() {
      const nextPage = this.page + 1;
      if (this.productData.length >= nextPage + this.itemsPerPage) {
        this.page = nextPage;
      } else {
        this.page = 0;
      }
    },
    PrevPage() {
      let prevPage = this.page - 1;
      if (prevPage >= 0) {
        this.page = prevPage;
      } else {
        prevPage = this.productData.length - this.itemsPerPage;
        this.page = prevPage <= 0 ? 0 : prevPage;
      }
    },
  },
  computed: {
    productData() {
      if (this.$store.state.productData == null) {
        return [];
      }
      const productTool = new ProductTool();
      const productData = productTool.getSortProductData(
        "default",
        this.menuId,
        ""
      );

      return productData;
    },
    itemsPerPage() {
      if (window.innerWidth > 1280) {
        return 4;
      } else if (window.innerWidth > 1024) {
        return 3;
      } else {
        return 2;
      }
    },
  },
  mounted() {
    // this.InitAnimation();
  },
};
</script>
